import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CLIENTS_QUERY_KEYS } from "Clients/Api/Queries/queryKeys";
import { deleteClientsClientIDDocumentsClientDocumentID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export function useDeleteClientDocumentMutation(clientID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((clientDocumentID: string) =>
      deleteClientsClientIDDocumentsClientDocumentID(
        clientID,
        clientDocumentID,
      ),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CLIENTS_QUERY_KEYS.documents(clientID),
      });
    },
  });
}
